module.exports = __webpack_public_path__ + "static/img/avatar-4.e0ab315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/avatar-4.jpg
// module id = qc3M
// module chunks = 1